import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons'

type ImagePreviewProps = {
  file: File | null | ''
  onDelete: () => void
}

const ImagePreview: React.FC<ImagePreviewProps> = (props) => {
  const [thumb, setThumb] = useState<string | undefined>(undefined)
  useEffect(() => {
    if (!props.file) {
      return
    }

    const objectUrl = URL.createObjectURL(props.file)
    setThumb(objectUrl)

    return () => URL.revokeObjectURL(objectUrl)
  }, [props.file])

  if (!props.file) return null

  return (
    <div className="relative mb-3 h-16 w-16">
      <span
        onClick={props.onDelete}
        className="absolute -right-1 -top-1 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-brand-500 p-2"
      >
        <FontAwesomeIcon className="h-5 w-5 text-white" icon={faMinusCircle} />
      </span>
      <img src={thumb} alt="preview" className="h-16 w-16 rounded-md" />
    </div>
  )
}

export default ImagePreview
